import React, {useContext} from 'react';
import {ShippingInstructionContext} from "./shipping-instruction-context";
import {Checkbox, FormControlLabel, Grid} from "@mui/material";
import {Controller} from "react-hook-form";

const CountryOverride = props => {

    const {data, setData, methods} = useContext(ShippingInstructionContext);
    const {control} = methods;
    return (
        <Grid container>
            <Grid item xs={6}>
                <FormControlLabel label="Registration Required" variant="outlined" control={
                    <Controller
                        name="registrationRequired"
                        control={control}
                        fullWidth
                        color="primary"
                        defaultValue={data.registrationRequired}
                        render={(
                            {onChange, onBlur, value, name, ref},
                            {invalid, isTouched, isDirty}
                        ) => (
                            <Checkbox
                                disabled={!data.overrideCountryDefaults}
                                onBlur={onBlur}
                                onChange={(e) => {
                                    onChange(e.target.checked);
                                    setData({...data, registrationRequired: e.target.checked})
                                }}
                                checked={value}
                                inputRef={ref}
                            />
                        )}
                    />
                }/>
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel label="Waiver Required" variant="outlined" control={
                    <Controller
                        name="waiverRequired"
                        control={control}
                        fullWidth
                        color="primary"
                        defaultValue={data.waiverRequired}
                        render={(
                            {onChange, onBlur, value, name, ref},
                            {invalid, isTouched, isDirty}
                        ) => (
                            <Checkbox
                                onBlur={onBlur}
                                disabled={!data.overrideCountryDefaults}
                                onChange={(e) => {
                                    onChange(e.target.checked);
                                    setData({...data, waiverRequired: e.target.checked})
                                }}
                                checked={value}
                                inputRef={ref}
                            />
                        )}
                    />
                }/>
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel label="Pre-Inspection Required" variant="outlined" control={
                    <Controller
                        name="preinspectionRequired"
                        control={control}
                        fullWidth
                        color="primary"
                        defaultValue={data.preinspectionRequired}
                        render={(
                            {onChange, onBlur, value, name, ref},
                            {invalid, isTouched, isDirty}
                        ) => (
                            <Checkbox
                                onBlur={onBlur}
                                disabled={!data.overrideCountryDefaults}
                                onChange={(e) => {
                                    onChange(e.target.checked);
                                    setData({...data, preinspectionRequired: e.target.checked})
                                }}
                                checked={value}
                                inputRef={ref}
                            />
                        )}
                    />
                }/>
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel label="Additional Info on Documents" variant="outlined" control={
                    <Controller
                        name="hasAdditionalDocumentInformation"
                        control={control}
                        fullWidth
                        color="primary"
                        defaultValue={data.hasAdditionalDocumentInformation}
                        render={(
                            {onChange, onBlur, value, name, ref},
                            {invalid, isTouched, isDirty}
                        ) => (
                            <Checkbox
                                onBlur={onBlur}
                                disabled={!data.overrideCountryDefaults}
                                onChange={(e) => {
                                    onChange(e.target.checked);
                                    setData({...data, hasAdditionalDocumentInformation: e.target.checked})
                                }}
                                checked={value}
                                inputRef={ref}
                            />
                        )}
                    />
                }/>
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel label="Special labeling required" variant="outlined" control={
                    <Controller
                        name="specialLabelingRequired"
                        control={control}
                        fullWidth
                        color="primary"
                        defaultValue={data.specialLabelingRequired}
                        render={(
                            {onChange, onBlur, value, name, ref},
                            {invalid, isTouched, isDirty}
                        ) => (
                            <Checkbox
                                onBlur={onBlur}
                                onChange={(e) => {
                                    onChange(e.target.checked);
                                    setData({...data, specialLabelingRequired: e.target.checked})
                                }}
                                checked={value}
                                inputRef={ref}
                            />
                        )}
                    />
                }/>
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel label="Has other requirements" variant="outlined" control={
                    <Controller
                        name="hasOtherRequirements"
                        control={control}
                        fullWidth
                        color="primary"
                        defaultValue={data.hasOtherRequirements}
                        render={(
                            {onChange, onBlur, value, name, ref},
                            {invalid, isTouched, isDirty}
                        ) => (
                            <Checkbox
                                onBlur={onBlur}
                                onChange={(e) => {
                                    onChange(e.target.checked);
                                    setData({...data, hasOtherRequirements: e.target.checked})
                                }}
                                checked={value}
                                inputRef={ref}
                            />
                        )}
                    />
                }/>
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel label="Has extra required documents" variant="outlined" control={
                    <Controller
                        name="hasExtraDocuments"
                        control={control}
                        fullWidth
                        color="primary"
                        defaultValue={data.hasExtraDocuments}
                        render={(
                            {onChange, onBlur, value, name, ref},
                            {invalid, isTouched, isDirty}
                        ) => (
                            <Checkbox
                                onBlur={onBlur}
                                onChange={(e) => {
                                    onChange(e.target.checked);
                                    setData({...data, hasExtraDocuments: e.target.checked})
                                }}
                                checked={value}
                                inputRef={ref}
                            />
                        )}
                    />
                }/>
            </Grid>
        </Grid>
    );
};

export default CountryOverride;